import Modal from './Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/views/components/Modal/index.js